import { useParams } from 'react-router-dom';

import type { UseAnalysisRouteParamsResult } from '../types';

export const useAnalysisRouteParams = (): UseAnalysisRouteParamsResult => {
  const params = useParams<{
    projectId: string;
    analysisProfileId: string;
    analysisVersionId: string;
  }>();
  return {
    projectId: params.projectId ?? '',
    analysisProfileId: params.analysisProfileId ?? '',
    analysisVersionId: params.analysisVersionId ?? '',
  };
};
